module.exports = __webpack_public_path__ + "static/media/Sofija.67e506ee.ttf";